const getAltSite = () => {
  let altSite = window.location.origin;

  if (altSite.includes('staging')) {
    if (altSite.includes('podcast'))
      altSite = altSite.replace('staging-podcast.', 'staging.');

    else
      altSite = altSite.replace('staging.', 'staging-podcast.');
  } else {
    if (altSite.includes('podcast.')) {
      altSite = altSite.replace('podcast.', 'app.');
    } else if (altSite.includes('channel.')) {
      altSite = altSite.replace('channel.', 'app.');
    } else {
      altSite = altSite.replace('app.', 'channel.');
    }
  }
  
  return altSite;
}

const useGetAltSite = () => {
  return getAltSite;
}

const useNavigateAltSite = () => {
  return (to: string) => {
    window.location.replace(`${getAltSite()}${to}`);
  }
}

export { useGetAltSite, useNavigateAltSite }